import sgImgS1 from '../images/service-single/web/img-1.jpg'
import sgImgS2 from '../images/service-single/web/img-2.jpg'
import sgImgS3 from '../images/service-single/web/img-3.jpg'

import brImgS1 from '../images/service-single/app/img-1.jpg'
import brImgS2 from '../images/service-single/app/img-2.jpg'
import brImgS3 from '../images/service-single/app/img-3.jpg'

import uxImgS1 from '../images/service-single/brand/img-1.jpg'
import uxImgS2 from '../images/service-single/brand/img-2.jpg'
import uxImgS3 from '../images/service-single/brand/img-3.jpg'

import dvImgS1 from '../images/service-single/market/img-1.jpg'
import dvImgS2 from '../images/service-single/market/img-2.jpg'
import dvImgS3 from '../images/service-single/market/img-3.jpg'



const Services = [
    {
        Id: '1',
        sImgS:sgImgS1,
        sTitle: 'Unreal or WebGL Development',
        description:'If you need to augment and strengthen your Unreal or 3D development team look no further.',
        des2:'Unreal Engine is a powerful beast when it comes to rendering capabilities. Wether it is a game or an advanced product configurator, custom functionality for Unreal needs to be build. I can help you by extending an existing team or by developing on my own in case this capability is not part of your normal development. Functionality can be delivered either as C++ code or plugins and where it makes sense as blueprint.',
        des3:'I can also support you with WebGL development, where I can help you build a custom solution for your needs. If you don\'t know what you need but you know what you want, then we can start by laying out which route is best for you to take.',
        icon:'flaticon-palette',
        projects:'213',
        ssImg1:sgImgS2,
        ssImg2:sgImgS3,
    },
    {
        Id: '2',
        sImgS:brImgS1,
        sTitle: 'General Development',
        description:'I am an expert in C++ and proficient in Swift, Objective-C and Typescript',
        des2:'Based on my long experience in software development and management, I can solve complex problems and deliver high-quality results. The lagnguage used is often secondary as I can pick up new ones as needed. However if you are in a hurry, then I am ready to start coding in C++, Swift, Objective-C and Typescript (and of course JavaScript if needed).',
        des3:'Beyond general programming I have a knack for anything revolving around high performance computing (for example using multithreading and/or SIMD instructions). I have also good experience in porting code between process architectures, compilers and platforms.',
        icon:'flaticon-coding',
        projects:'102',
        ssImg1:brImgS2,
        ssImg2:brImgS3,
    },
    {
        Id: '3',
        sImgS:uxImgS1,
        sTitle: 'Interim Team Lead',
        description:'I can jump in where a team leader is missing, with or without coding responsibilities.',
        des2:'You probably want your own staff to lead your team(s) - sure, I get that. But sometimes things don\'t work out the way you want them to - this is where I can come in to help in the interim until things fall into place.',
        des3:'I have more than 15 years of experience in leading software development teams, both in small start ups and large corporations (and anything in between). I have build teams of 20 from scratch or taken over existing teams of 30+. If you need a leader with deep technical understanding, people skills and also an eye for the economic aspects of the business, then I can help.',
        icon:'flaticon-self-growth',
        projects:'60',
        ssImg1:uxImgS2,
        ssImg2:uxImgS3,
    },
    {
        Id: '4',
        sImgS:dvImgS1,
        sTitle: 'Strategic Advisor',
        description:'Need advise with all the new tech buzz words coming up? Where to invest and where best not to? I can help.',
        des2:'Sometimes you just need a little help to sort out whats what. I don\'t have all the answers, but I have a good deal when it comes to tech and I am good in researching and finding those answers that you are concerned about.',
        des3:'Due to my experience of driving a business myself, but also working in context of large organizations, I have a good overview of the general challenges businesses can face. Together we can find the best way to navigate those challenges.',
        icon:'flaticon-bar-chart',
        projects:'230',
        ssImg1:dvImgS2,
        ssImg2:dvImgS3,
    }
]    

export default Services;